import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { languages } from "../../../../utils/constants";
import cookies from "js-cookie";
import useOutsideClick from "../../../../hooks/useOutsideClick";
import { arrowDown, arrowUp } from "../../../../assets/svgs";
import { navigateWithLocal } from "../../../../utils/helpers";
import "./language.scss";

export const Language = () => {
  const navigate = useNavigate();

  const { i18n } = useTranslation();
  const { pathname } = useLocation();
  const { language } = useParams();

  const lngRef = useRef();

  const [openLng, setOpenLng] = useState(false);

  const selected = languages.find(({ code }) => code === language);

  const handleOpenLng = () => {
    setOpenLng(!openLng);
  };

  const handleChangeLng = (code) => {
    setOpenLng(false);
    i18n.changeLanguage(code);
    cookies.set("i18next", code);
    navigate(`/${code}${navigateWithLocal(pathname)}`);
  };

  useOutsideClick(lngRef, openLng, setOpenLng);

  return (
    <div className="language" ref={lngRef}>
      <div className="language__choose" onClick={handleOpenLng}>
        {selected?.country_code}
        {!openLng ? arrowDown.icon : arrowUp.icon}
      </div>

      <ul
        className={
          !openLng ? "language__dropdown" : "language__dropdown-active"
        }
      >
        {languages
          .filter((el) => el.code !== selected?.code)
          .map(({ code, country_code }) => (
            <li key={code} onClick={() => handleChangeLng(code)}>
              {country_code}
            </li>
          ))}
      </ul>
    </div>
  );
};
